import { withSearch } from '@elastic/react-search-ui';
import MultiCheckboxFilter from '../../../components/filter/MultiCheckboxFilter';

function ArchiveLevelFilter({ addFilter, removeFilter, facets, filters }) {
  return (
    <MultiCheckboxFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="level"
      filters={filters}
      formHint="Select all that apply."
      id="level"
      label="Structure"
      orderByCount={false}
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, facets, filters }) => ({
  addFilter,
  removeFilter,
  facets,
  filters,
}))(ArchiveLevelFilter);
